import{a as l}from"./ids-chunk-U4K5B3VN.js";import{a as r,b as d}from"./ids-chunk-XE4WFW5M.js";import{a as m}from"./ids-chunk-W3LDHTW6.js";import{b as i}from"./ids-chunk-TFRXZ5TN.js";import{a as s,d as o,f as a}from"./ids-chunk-ZMMCFAAI.js";var c=`/* Ids Menu Header Component */
:host {
  display: block;
}

.ids-menu-header {
  margin-block: var(--ids-menu-header-margin);
  padding-inline: var(--ids-menu-header-padding);
  font-weight: var(--ids-menu-header-font-weight);
  font-size: var(--ids-menu-header-font-size);
  color: var(--ids-menu-header-color-text);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  list-style: none;
  text-align: start;
}
.ids-menu-header.align-for-icons {
  padding-inline-start: var(--ids-menu-header-icon-padding);
}`;var n,h,e=class extends l(m){constructor(){super();o(this,n)}connectedCallback(){super.connectedCallback(),this.setAttribute(i.ROLE,"none"),a(this,n,h).call(this),this.menu&&this.decorateForIcon(this.menu.hasIcons)}static get attributes(){return[...super.attributes]}get menu(){return this.parentElement}template(){return'<div class="ids-menu-header" part="header" role="none"><slot></slot></div>'}decorateForIcon(t){this.container?.classList[t?"add":"remove"]("align-for-icons")}};n=new WeakSet,h=function(){let t=this.container.querySelector("slot");this.offEvent("slotchange",t),this.onEvent("slotchange",t,()=>{this.decorateForIcon(this.menu.hasIcons)})},e=s([r("ids-menu-header"),d(c)],e);export{e as a};
